import classNames from 'classnames'

import classes from './TwoButtonToggle.module.scss'
import PropTypes from 'prop-types'
import { useState } from 'react'


const TwoButtonToggle = ({ checked, onChange, name, disabled, checkedText = 'On', uncheckedText = 'Off', defaultChecked = null }) => {
  const isUncontrolled = !onChange || defaultChecked !== null
  const [checked_, setChecked_] = useState(!!defaultChecked)

  return (
    <div role='radiogroup' aria-labelledby='toggle' className={classNames(classes.wrapper, { [classes.disabled]: disabled })}>
      <button
        type='button'
        role='radio'
        aria-checked={isUncontrolled ? checked_ : checked}
        className={classNames(classes.roundButton, { [classes.active]: isUncontrolled ? checked_ : checked })}
        onClick={isUncontrolled ? (() => setChecked_(true)) : (() => onChange(true))}
      >
        {checkedText}
      </button>
      <button
        type='button'
        role='radio'
        aria-checked={isUncontrolled ? !checked_ : !checked}
        className={classNames(classes.roundButton, { [classes.active]: isUncontrolled ? !checked_ : !checked })}
        onClick={isUncontrolled ? (() => setChecked_(false)) : (() => onChange(false))}
      >
        {uncheckedText}
      </button>
      {isUncontrolled && (
        <input type='hidden' name={name} value={checked_} />
      )}
    </div>
  )
}

TwoButtonToggle.propTypes = {
  name: PropTypes.string,
  checkedText: PropTypes.string,
  uncheckedText: PropTypes.string,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  defaultChecked: PropTypes.bool,
  onChange: PropTypes.func,
}

export default TwoButtonToggle
